export const FETCH_STATIC_DATA_STARTED = 'FETCH_STATIC_DATA_STARTED';
export const FETCH_STATIC_DATA_SUCCEEDED = 'FETCH_STATIC_DATA_SUCCEEDED';
export const FETCH_STATIC_DATA_FAILED = 'FETCH_STATIC_DATA_FAILED';
